import { useMemo } from 'react';

import { useConfigurationStore } from 'store/configurationsStore';

import { IComponentKey, IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that are part of Portfolio Dashboard,
 * and do not have project and contract context
 */

export const usePortfolioComponentKeys = (): IComponentKey[] => {
    const configuration = useConfigurationStore();
    return useMemo(
        () => [
            configuration.projectScorecards.componentKey as keyof IHashmap,
            configuration.timelineAndDensity.componentKey as keyof IHashmap,
        ],
        [],
    );
};
